import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';

const enhance = compose(
  withState('confirmationScreen', 'setConfirmationScreen', false),
  withHandlers({
    hideConfirmationScreen: props => () => props.setConfirmationScreen(false),
    showConfirmationScreen: props => () => props.setConfirmationScreen(true),
  })
);

export default enhance;
